import { render } from "./FloatingSidebar.vue?vue&type=template&id=28ed918a&scoped=true"
import script from "./FloatingSidebar.vue?vue&type=script&lang=js"
export * from "./FloatingSidebar.vue?vue&type=script&lang=js"

import "./FloatingSidebar.vue?vue&type=style&index=0&id=28ed918a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ed918a"]])

export default __exports__